import React from 'react';
import PropTypes from 'prop-types';

export function SvgCrossTrends(props) {
  const { width = 24, height = 24, stroke = '#000' } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd" stroke="none" strokeLinejoin="round" strokeWidth="1">
        <g stroke={stroke} strokeWidth="2" transform="translate(-483 -491)">
          <g transform="translate(259 386)">
            <g transform="translate(171 104)">
              <g transform="translate(53 1)">
                <g transform="translate(4 5.003)">
                  <path d="M15-.003l-8.5 9-3.5-1-3 5.5M11.333 0h4v4" />
                </g>
                <g transform="matrix(1 0 0 -1 4 18)">
                  <path d="M14.5 1l-8 8L3 8.5l-3 5M11.333 0h4v4" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

SvgCrossTrends.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};
